import React, {useState, createContext, useEffect} from 'react'

import {ObtenerEmpresaPorId} from '../microservicios/Empresa'

import {FormularioSeleccionEmpresa} from '../componentes/Modales'

export const ContextoAplicacion = createContext('Default Value')

export const Provider = ({children}) => {
  const [modal, setModal] = useState({
    id: 0,
    abierto: false,
    titulo: '',
    contenido: '',
    botones: [],
  })
  const [cargando, setCargando] = useState(false)
  const [infoEmpresa, setInfoEmpresa] = useState({
    id: 0,
    nombre: '',
    imagen: '',
    tipoFacturacion: '',
  })
  const [countFetching, setCountFetching] = useState(0)
  const [configurado, setConfigurado] = useState(false)

  const obtenerEmpresaPortalCliente = async (idEmpresa) => {
    const res = await ObtenerEmpresaPorId(idEmpresa)
    if (res.status === 200) {
      setInfoEmpresa({
        id: res.data.id,
        nombre: res.data.nombre.toUpperCase(),
        imagen: res.data.logoUrl,
        tipoFacturacion: res.data.facturacionEmpresa.tipoFacturacion,
        correoFacturacion: res.data.facturacionEmpresa.correoFacturacion,
      })
      setModal({
        abierto: false,
        clasesAdicionales: '',
        contenido: '',
        botones: [],
      })
      sessionStorage.setItem('empresaSeleccionadaId', res.data.id)
    }
  }

  useEffect(() => {
    const validarExisteIdEmpresa = () => {
      const idEmpresaSessionStorage = sessionStorage.getItem(
        'empresaSeleccionadaId'
      )
      if (idEmpresaSessionStorage) {
        obtenerEmpresaPortalCliente(idEmpresaSessionStorage)
      }
    }
    if (configurado) {
      validarExisteIdEmpresa()
    }
  }, [configurado])

  const abrirModalSeleccionEmpresa = async (empresas) => {
    setModal({
      abierto: true,
      clasesAdicionales: 'w-5/12 border border-cendiatra',
      contenido: (
        <FormularioSeleccionEmpresa
          arregloEmpresas={empresas}
          funcionBuscarEmpresa={(e) => obtenerEmpresaPortalCliente(e)}
        />
      ),
      botones: [],
    })
  }

  return (
    <ContextoAplicacion.Provider
      value={{
        modal: modal,
        setModal: setModal,
        cargando: cargando,
        setCargando: setCargando,
        infoEmpresa: infoEmpresa,
        setInfoEmpresa: setInfoEmpresa,
        abrirModalSeleccionEmpresa: abrirModalSeleccionEmpresa,
        obtenerEmpresaPortalCliente: obtenerEmpresaPortalCliente,
        configurado: configurado,
        setConfigurado: setConfigurado,
        countFetching: countFetching,
        setCountFetching: setCountFetching,
      }}
    >
      {children}
    </ContextoAplicacion.Provider>
  )
}
